import {
    FETCH_STATES_REQUEST, FETCH_STATES_SUCCESS, FETCH_STATES_FAILURE,
    CREATE_STATE_SUCCESS, UPDATE_STATE_SUCCESS, DELETE_STATE_SUCCESS
  } from '../actions/stateActions';
  
  const initialState = {
    states: [],
    loading: false,
    error: null,
  };
  
  export default function stateReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_STATES_REQUEST:
        return { ...state, loading: true };
      case FETCH_STATES_SUCCESS:
        return { ...state, loading: false, states: action.payload };
      case CREATE_STATE_SUCCESS:
        return { ...state, states: [...state.states, action.payload] };
      case UPDATE_STATE_SUCCESS:
        return {
          ...state,
          states: state.states.map((s) =>
            s.id === action.payload.id ? action.payload : s
          ),
        };
      case DELETE_STATE_SUCCESS:
        return {
          ...state,
          states: state.states.filter((s) => s.id !== action.payload),
        };
      default:
        return state;
    }
  }
  